/**
 * Messages for the result of a broker login redirect (`/broker-accounts?connected=<broker>&error=<code>`),
 * set by the backend callback routes in `app.api.v1.broker_accounts`.
 */
/** Labels for the `connected=` query param set by the backend's broker redirect callbacks. */
export const CALLBACK_BROKER_LABEL: Record<string, string> = { zerodha: "Zerodha", angel_one: "Angel One" };

export function callbackErrorMessage(name: string, errorCode: string): string {
  switch (errorCode) {
    case "login_cancelled":
      return `${name} login was cancelled.`;
    case "login_expired":
      return `The ${name} login could not be verified or took too long. Please try again.`;
    case "state_missing":
      return `${name} did not return the login reference TekInvest needs. Please try again; if it keeps happening, contact your administrator.`;
    case "auth_rejected":
      return `${name} rejected the session. Please log in to ${name} again.`;
    case "broker_unreachable":
      return `Could not reach ${name} to verify the login. Please try again shortly.`;
    default:
      return `Connecting to ${name} failed. Please try again.`;
  }
}
